function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useState } from 'react';
import useAuthQueryParams from './utils/use-auth-query-params';
import useFollowedPropertyControl from './utils/use-followed-property-control';
import { ResponseStatus } from './types';
import { useUpdateFollowedPropertyMutation } from './graphql/update-followed-property.mutation.generated';
var useUpdateRelationship = function useUpdateRelationship() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onCompleted = _ref.onCompleted;
  var _useAuthQueryParams = useAuthQueryParams(),
    mutationParams = _useAuthQueryParams.mutationParams;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRelationship = _useState2[0],
    setSelectedRelationship = _useState2[1];
  var _useUpdateFollowedPro = useUpdateFollowedPropertyMutation(_objectSpread(_objectSpread({}, mutationParams), {}, {
      refetchQueries: 'active'
    })),
    _useUpdateFollowedPro2 = _slicedToArray(_useUpdateFollowedPro, 2),
    updateFollowedProperty = _useUpdateFollowedPro2[0],
    mutationLoading = _useUpdateFollowedPro2[1].loading;
  var onSubmit = useCallback(followedProperty => updateFollowedProperty({
    variables: {
      followedProperty: {
        id: followedProperty.id,
        relationship: selectedRelationship
      }
    }
  }).then(_ref2 => {
    var data = _ref2.data;
    if ((data === null || data === void 0 ? void 0 : data.updateFollowedProperty.status) !== ResponseStatus.OK) {
      throw new Error((data === null || data === void 0 ? void 0 : data.updateFollowedProperty.message) || '');
    }
  }), [selectedRelationship, updateFollowedProperty]);
  var _useFollowedPropertyC = useFollowedPropertyControl({
      action: 'update',
      onReset: () => {
        setSelectedRelationship(null);
      },
      onFollowedPropertyLoaded: followedProperty => {
        setSelectedRelationship(followedProperty.relationship);
      },
      onSubmit,
      onCompleted
    }),
    followedPropertyResult = _useFollowedPropertyC.followedPropertyResult,
    queryLoading = _useFollowedPropertyC.queryLoading,
    openModal = _useFollowedPropertyC.openModal,
    modalProps = _useFollowedPropertyC.modalProps;
  var updateRelationshipProps = selectedRelationship && (followedPropertyResult === null || followedPropertyResult === void 0 ? void 0 : followedPropertyResult.followedProperty) && _objectSpread(_objectSpread({}, modalProps), {}, {
    loading: queryLoading || mutationLoading,
    address: followedPropertyResult.followedProperty.property.address,
    selectedRelationship,
    onRelationshipChange: setSelectedRelationship
  });
  return {
    updateRelationshipProps,
    openUpdateRelationship: openModal
  };
};
export default useUpdateRelationship;